import { Component, OnInit, AfterViewInit, OnDestroy, ViewChild } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { Router, NavigationExtras,ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { DatePipe } from '@angular/common';
import { ConfirmationDialogService } from '../confirmation-dialog/confirmation-dialog.service';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import { ReportfilterComponent } from '../grid/reportfilter/reportfilter.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment';
import { ExportgridComponent } from '../grid/exportgrid/exportgrid.component';
@Component({
  selector: 'app-employeesalaryreport',
  templateUrl: './employeesalaryreport.component.html',
  styleUrls: ['./employeesalaryreport.component.css']
})
export class EmployeesalaryreportComponent implements OnInit {

  @ViewChild('filterbar',{static:false}) filterbar;

  isadd:boolean=false;
  isedit:boolean=false;
  isdelete:boolean=false;
  isview:boolean=false;
  isprint:boolean=false;
  isexport: boolean = false;
  isfilter: boolean = false;

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;


  formname: string = "EmployeeSalaryReport";

  filterstatus: string = "ALL";
  dtOptions: DataTables.Settings = {};
    
  empsalaryColl:any=[];

  fromdate:any=null;
  todate:any=null;

  filterempid:any=null;
  filterempname:any='';

 

  searchtxt: any = "";


  columnDefs = [
    { headerName: 'Staff Code', field: 'staffcode' },
    { headerName: 'Employee Name', field: 'empname' },
    { headerName: 'Designation', field: 'designationname' },
    { headerName: 'Allowance Name', field: 'allowancename' },
    { headerName: 'Deduction Name', field: 'deductionname' },
    { headerName: 'Amount', field: 'amount' },
    ]

  gridOptions = {
    enableactioncol: false,
    columnDefs: this.columnDefs,
  };

  dateCustomClasses: DatepickerDateCustomClasses[];
  constructor( private appService:AppdataService,private loginService:LoginserviceService,public router: Router,private route: ActivatedRoute,
    private confirmationDialogService: ConfirmationDialogService,private toastr: ToastrService,private datePipe: DatePipe, private productFindService: NgbModal) {
      this.fnServiceChanges();
      this.fnGetParameterVariable();
      this.dateCustomClasses = [
        { date: new Date(), classes: ['bg-warning'] },
      ];
  }
  fnGetParameterVariable() {
    this.route.queryParams.subscribe(params => {
      if (params.empid !== undefined) {
        this.filterempid = params.empid
      }
      if (params.empname !== undefined) {
        this.filterempname = params.empname
      }
     
    })
  }
  //Company Check
  fnServiceChanges(){
    this.loginService.serviceAuthChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        this.fnCheckPrivilage();
        if (this.isview) {
          this.isloading=true;
          this.fnOnInitForm();
        }
        else{
          this.fnUserFailedForm();
        }   
        
      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }
    });
  }
  
  //Init
  ngOnInit() {
    try{
      if(this.loginService.fnCheckCompany()){         
        this.fnCheckPrivilage();
        if(this.isview){
          this.isloading=true;
          this.fnOnInitForm();
        }
        else{
          this.fnUserFailedForm();
        }          
      }
      else{
        this.loginService.fnGetUserRoleList();
      } 
    }catch(ex){
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm(){
    this.fngetEmpSalaryReportReport();     
  }


  fnCheckPrivilage() {
    
    this.isadd=this.loginService.fnCheckUserRoleAction(this.formname,'CREATE');
    this.isedit=this.loginService.fnCheckUserRoleAction(this.formname,'ALTER');
    this.isdelete=this.loginService.fnCheckUserRoleAction(this.formname,'DELETE');
    this.isview=this.loginService.fnCheckUserRoleAction(this.formname,'VIEW');
    this.isprint=this.loginService.fnCheckUserRoleAction(this.formname,'PRINT');
    this.isexport = this.loginService.fnCheckUserRoleAction(this.formname, 'EXPORT');
    
    
  }

  fnUserFailedForm(){
    this.isprivilage=true;
  }
 
  
  

    fnActionExportClick()  {
        const params = {
          columnGroups: true,
          allColumns: true,
          fileName: 'empsalarylist',
          //columnSeparator: document.querySelector("#columnSeparator").value
        };
        //this.gridApi.exportDataAsCsv(params);
    }

    fnActionFilterClick() {  

      // this.filterbar.filterstatus = this.filterstatus;
      
      // this.isfilter = !this.isfilter;
      this. fnShowFilterPopup()
    }
    
    fnActionRefreshClick() { 
      this.fngetEmpSalaryReportReport()
    }
    fnApplyFilterPop(data) {
      // this.isfilter = !this.isfilter;
  
      this.filterstatus = data;
      this.filterempid = data.empid;
      this.filterempname = data.empname;
     
  
      this.fngetEmpSalaryReportReport();
  
    }
  
    fnApplyFilter(data) {
     // this.isfilter = !this.isfilter;
  
      this.filterstatus = data;
  
      this.fngetEmpSalaryReportReport();
       
    }
  
    fnCurrentRouteChange() { 
      var queryParams = {};
      
  
      if (this.filterstatus != '') {     
        queryParams['status'] = this.filterstatus;
      }   
  
       this.router.navigate(
        [], 
        {
          relativeTo: this.route,
          queryParams: queryParams, 
        
        });
    }
    
    
  
  
  //Get
  fngetEmpSalaryReportReport() {
    if(this.showProgress){
      return;
    }

    this.fnShowProgress();       
      var data = {
        'empid':this.filterempid,
        'filterstatus':'',
          'fromdate':this.fnFormatDatetime(this.fromdate),
          'todate':this.fnFormatDatetime(this.todate),
          'companyid': this.loginService.fnGetCompanyId(),  
          'modifiedby':this.loginService.fnGetModUserId(),                                                                           
          
      }
      this.appService.getEmpSalaryReport(data)
      .subscribe(
          (res)=>{                  
            if(res.json().status===200){
              this.fnHideProgress();                   
             
              this.empsalaryColl = res.json().result;   
             console.log(this.empsalaryColl)
              this.fnSetTable();
            this.fnCurrentRouteChange();        
              
            }else {
              this.fnHideProgress();                   

                this.loginService.fnAPIError(res.json())
            }             
          },
          (err)=>{  
            this.fnHideProgress();                   
        
              this.toastr.error('Error', err);
      })
  }
  


  fnShowFilterPopup() {

    const modalRef = this.productFindService.open(ReportfilterComponent, { size: <any>'xl' });
    modalRef.componentInstance.formname = this.formname;
    modalRef.componentInstance.empid = Number(this.filterempid);
    // modalRef.componentInstance.fromdate = this.filterfromdate;
    // modalRef.componentInstance.todate = this.filtertodate;

    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

      console.log(receivedEntry)

      if (receivedEntry.status === 'DONE') {
        this.filterempid = receivedEntry.empid;
        this.filterempname = receivedEntry.empname;
       
        this.fngetEmpSalaryReportReport();
      }


    });
  }
  
  private fnExport() {

    const modalRef = this.productFindService.open(ExportgridComponent, { size: <any>'xxl', backdrop: 'static' });
    modalRef.componentInstance.doctype = this.formname;
    modalRef.componentInstance.columnDefs = this.columnDefs;
    modalRef.componentInstance.contentColl = this.empsalaryColl;
    modalRef.componentInstance.fnSetTable();
    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {
  
    
    });
  
  }


  fnSetTable() {
    
  }

  public fnSearchDatatable(value){    
   
  }

  private fnFocusTableRow(index,status){
    if(index>-1){
      if(status==='IN'){          
        this.empsalaryColl[index].hoverfocus="IN"
      }
      else{
        this.empsalaryColl[index].hoverfocus=""
      }                
    }    
}
  
fnMomentDateFormatter(params) {
  if (params.value) {
    return moment(params.value).format('DD-MM-YYYY');//  
  }
  else {
    return '';
  }

}  

fnFormatDatetime(dt){
  if(dt){
    if(dt===""){
      return null
    }
    else{
      return this.datePipe.transform(dt,"dd-MM-yyyy")  
    }
    
    }else {
    return null
  }
  
}
  
fngetDescriptionRefno(data){
  var rtnstr="";
  try{
      if(data.transdt){
        rtnstr=rtnstr+data.transdt;
      }

      if(data.empid){
        rtnstr=rtnstr+" - "+data.empid;
      }

      if(data.empname){
        rtnstr=rtnstr+" - "+data.empname;
      }
    }catch{
    
    }
  return rtnstr;
}


  fnCloseForm(){
    try{
      this.router.navigate(['/Reports']);
    }catch(ex){
       this.fnShowErrorMsg(ex);
    }
    }
fnInsertActivityLog(action,refno,desc){
  try{
    var data={
      logtype:action,
      logat:this.formname,
      refnum:refno,
      logdescr:desc,companyid: this.loginService.fnGetCompanyId(),         
      logby:this.loginService.fnGetModUserId(),
    }
  

    this.appService.fnInsertActivity(data).subscribe(
      (res)=>{
      },
      (err)=>{
     
      });

  }catch{

  }
}
private fnShowProgress() {
  this.showProgress = true;
}
private fnHideProgress() {
  this.showProgress = false;
} 
  private  fnShowErrorMsg(ex){
    this.toastr.warning('Internal Error', ex);       
  }








}
